import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';

import {
  LOAN_DETAIL_CHANGED,
} from '../../actions/types'

import {
  updateLoanDetailCalculator,
} from '../../actions'

import { postLoanSetupCalculator } from '../../requesters/loanApplication'

import {
  getLoanApplicationId,
  getLoanDetailParams,
   } from '../../reducers'

function* loanSetupCalculator({type, payload}) {
  const loanDetail = yield select(getLoanDetailParams);
  const loanApplicationId = yield select(getLoanApplicationId);
  const interestType = ( payload.interestType !== undefined ) ? payload.interestType : loanDetail.interestType

  const data = {
    loan_setup_calc: {
      loan_detail_attributes: {
        interestType: interestType,
        fixed: { ...loanDetail.fixed, ...payload.fixed },
        variable: { ...loanDetail.variable, ...payload.variable },
      }
    }
  }

  const { response, error } = yield call(postLoanSetupCalculator, loanApplicationId, data)

  if (response) {
    yield put(updateLoanDetailCalculator({
      loanSetupCalculator: response,
    }))
  } else {
    yield put(updateLoanDetailCalculator({
      loanSetupCalculator: {},
    }))
  }
}

export function* watchLoanSetupCalculator() {
  yield takeLatest(LOAN_DETAIL_CHANGED, loanSetupCalculator)
}
